var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "invoices" }, [
    _c(
      "div",
      { staticClass: "main-wrapper" },
      [
        _c("layout-header"),
        _vm._v(" "),
        _c("layout-sidebar"),
        _vm._v(" "),
        _c("div", { staticClass: "page-wrapper" }, [
          _c("div", { staticClass: "content container-fluid" }, [
            _c("div", { staticClass: "page-header" }, [
              _c("div", { staticClass: "row align-items-center" }, [
                _c("div", { staticClass: "col" }, [
                  _c("h3", { staticClass: "page-title" }, [
                    _vm._v("Official — Instagram Full Access")
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "breadcrumb" }, [
                    _c(
                      "li",
                      { staticClass: "breadcrumb-item" },
                      [
                        _c("router-link", { attrs: { to: "/index" } }, [
                          _vm._v("Dashboard")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "breadcrumb-item" },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: { to: "/instagram/accounts/list_official" }
                          },
                          [_vm._v("List Accounts")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("li", { staticClass: "breadcrumb-item active" }, [
                      _vm._v("Add Account")
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-12 col-lg-6 col-xl-6 d-flex" }, [
                _c("div", { staticClass: "card container" }, [
                  _c("div", { staticClass: "row align-items-center h-100" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "multiselect",
                              {
                                attrs: {
                                  id: "ajax",
                                  label: "brand_name",
                                  "track-by": "id",
                                  placeholder: "Type to search Brand...",
                                  multiple: true,
                                  "open-direction": "bottom",
                                  "custom-label": _vm.customLabel,
                                  options: _vm.contactOptions,
                                  searchable: true,
                                  loading: _vm.isLoading,
                                  "internal-search": false,
                                  "close-on-select": false,
                                  "options-limit": 300,
                                  limit: 3,
                                  "limit-text": _vm.limitText,
                                  "max-height": 600,
                                  "show-no-results": true,
                                  "hide-selected": true,
                                  "show-labels": false
                                },
                                on: { "search-change": _vm.asyncFind },
                                scopedSlots: _vm._u([
                                  {
                                    key: "tag",
                                    fn: function(ref) {
                                      var option = ref.option
                                      var remove = ref.remove
                                      return [
                                        _c(
                                          "span",
                                          { staticClass: "custom__tag" },
                                          [
                                            _c("span", [
                                              _vm._v(_vm._s(option.name))
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "custom__remove",
                                                on: {
                                                  click: function($event) {
                                                    return remove(option)
                                                  }
                                                }
                                              },
                                              [_vm._v("❌")]
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "clear",
                                    fn: function(props) {
                                      return [
                                        _vm.selectedContact.length
                                          ? _c("div", {
                                              staticClass: "multiselect__clear",
                                              on: {
                                                mousedown: function($event) {
                                                  $event.preventDefault()
                                                  $event.stopPropagation()
                                                  return _vm.clearAll(
                                                    props.search
                                                  )
                                                }
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.selectedContact,
                                  callback: function($$v) {
                                    _vm.selectedContact = $$v
                                  },
                                  expression: "selectedContact"
                                }
                              },
                              [
                                _vm._v(" "),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    attrs: { slot: "noResult" },
                                    slot: "noResult"
                                  },
                                  [_vm._v("Oops! No elements found.")]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _vm.selectedContact.length
                        ? _c("div", { staticClass: "text-center" }, [
                            _vm.loadingFB
                              ? _c(
                                  "div",
                                  { staticStyle: { "margin-top": "20px" } },
                                  [_vm._v("Sedang mengalihkan...")]
                                )
                              : _c(
                                  "div",
                                  [
                                    _vm.FBComponent.scope.logout &&
                                    _vm.FBComponent.model.connected
                                      ? _c("v-facebook-login", {
                                          staticClass:
                                            "btn-default-costume btn-facebook",
                                          style: "width:100%;margin-top:10px;",
                                          attrs: {
                                            type: "button",
                                            "app-id": _vm.FBComponent.appId,
                                            "use-alt-logo": true,
                                            tabindex: "6",
                                            version: "v16.0",
                                            "login-options":
                                              _vm.FBComponent
                                                .scopeInstagramPermissionsInsight
                                          },
                                          on: {
                                            "sdk-init": _vm.handleSdkInit,
                                            login: _vm.handleSdkLogin
                                          },
                                          model: {
                                            value: _vm.FBComponent.model,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.FBComponent,
                                                "model",
                                                $$v
                                              )
                                            },
                                            expression: "FBComponent.model"
                                          }
                                        })
                                      : _c("v-facebook-login", {
                                          staticClass:
                                            "btn-default-costume btn-facebook",
                                          style: "width:100%;margin-top:10px;",
                                          attrs: {
                                            type: "button",
                                            tabindex: "6",
                                            "app-id": _vm.FBComponent.appId,
                                            "use-alt-logo": true,
                                            version: "v16.0",
                                            "login-options":
                                              _vm.FBComponent
                                                .scopeInstagramPermissionsInsight
                                          },
                                          on: {
                                            "sdk-init": _vm.handleSdkInit,
                                            login: _vm.handleSdkLogin
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "login",
                                                fn: function() {
                                                  return [
                                                    _vm._v(
                                                      "Masuk Dengan Facebook"
                                                    )
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            false,
                                            1251041968
                                          ),
                                          model: {
                                            value: _vm.FBComponent.model,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.FBComponent,
                                                "model",
                                                $$v
                                              )
                                            },
                                            expression: "FBComponent.model"
                                          }
                                        })
                                  ],
                                  1
                                )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12" }, [_vm._v(" ")])
                  ])
                ])
              ])
            ])
          ])
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        directives: [
          { name: "show", rawName: "v-show", value: false, expression: "false" }
        ],
        ref: "formSelectAccounts",
        staticClass: "btn add-btn",
        attrs: {
          href: "#",
          "data-toggle": "modal",
          "data-target": "#formSelectAccounts"
        }
      },
      [_c("i", { staticClass: "la la-user" }), _vm._v(" Select Accounts\n  ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal custom-modal fade",
        attrs: { id: "formSelectAccounts", role: "dialog" }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-dialog-centered modal-lg",
            attrs: { role: "document" }
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v("Select Accounts")
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    ref: "dismisModal",
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "modal",
                      "aria-label": "Close"
                    }
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×")
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "col-md-12 col-lg-12 col-xl-12" }, [
                  _c("div", { staticClass: "text-right" }, [
                    _c("div", { staticClass: "checkbox" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectAllTable,
                              expression: "selectAllTable"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.selectAllTable)
                              ? _vm._i(_vm.selectAllTable, null) > -1
                              : _vm.selectAllTable
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.selectAllTable,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.selectAllTable = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.selectAllTable = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.selectAllTable = $$c
                              }
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12 col-lg-12 col-xl-12 d-flex" },
                  [
                    _vm.instagramAccounts.length
                      ? _c(
                          "div",
                          { staticClass: "flex-fill" },
                          [
                            _vm._l(_vm.instagramAccounts, function(row, idx) {
                              return [
                                row.instagram_business_account.id != ""
                                  ? _c(
                                      "div",
                                      {
                                        key: idx,
                                        staticClass: "leave-info-box"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "media align-items-center"
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "avatar",
                                                attrs: {
                                                  href:
                                                    "https://www.instagram.com/" +
                                                    row
                                                      .instagram_business_account
                                                      .username,
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  staticStyle: {
                                                    width: "100%"
                                                  },
                                                  attrs: {
                                                    alt: "",
                                                    src:
                                                      row
                                                        .instagram_business_account
                                                        .profile_picture_url
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "media-body" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-sm my-0"
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href:
                                                            "https://www.instagram.com/" +
                                                            row
                                                              .instagram_business_account
                                                              .username,
                                                          target: "_blank"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            row
                                                              .instagram_business_account
                                                              .username
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "row align-items-center mt-3"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-6" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-sm text-muted"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        row
                                                          .instagram_business_account
                                                          .name
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-6 text-right"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "checkbox" },
                                                  [
                                                    _c("label", [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.selectedTable,
                                                            expression:
                                                              "selectedTable"
                                                          }
                                                        ],
                                                        attrs: {
                                                          type: "checkbox"
                                                        },
                                                        domProps: {
                                                          value:
                                                            row
                                                              .instagram_business_account
                                                              .id,
                                                          checked: Array.isArray(
                                                            _vm.selectedTable
                                                          )
                                                            ? _vm._i(
                                                                _vm.selectedTable,
                                                                row
                                                                  .instagram_business_account
                                                                  .id
                                                              ) > -1
                                                            : _vm.selectedTable
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            var $$a =
                                                                _vm.selectedTable,
                                                              $$el =
                                                                $event.target,
                                                              $$c = $$el.checked
                                                                ? true
                                                                : false
                                                            if (
                                                              Array.isArray($$a)
                                                            ) {
                                                              var $$v =
                                                                  row
                                                                    .instagram_business_account
                                                                    .id,
                                                                $$i = _vm._i(
                                                                  $$a,
                                                                  $$v
                                                                )
                                                              if (
                                                                $$el.checked
                                                              ) {
                                                                $$i < 0 &&
                                                                  (_vm.selectedTable = $$a.concat(
                                                                    [$$v]
                                                                  ))
                                                              } else {
                                                                $$i > -1 &&
                                                                  (_vm.selectedTable = $$a
                                                                    .slice(
                                                                      0,
                                                                      $$i
                                                                    )
                                                                    .concat(
                                                                      $$a.slice(
                                                                        $$i + 1
                                                                      )
                                                                    ))
                                                              }
                                                            } else {
                                                              _vm.selectedTable = $$c
                                                            }
                                                          }
                                                        }
                                                      })
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-right" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-light text-dark",
                                  attrs: {
                                    href: "javascript:void(0);",
                                    "data-dismiss": "modal"
                                  }
                                },
                                [_vm._v("Cancel")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: { disabled: _vm.loadingConnect },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.connectAccountsFullAccess(
                                        $event
                                      )
                                    }
                                  }
                                },
                                [_vm._v("Connect")]
                              )
                            ])
                          ],
                          2
                        )
                      : _c("div", { staticClass: "flex-fill" }, [
                          _c(
                            "div",
                            { staticClass: "text-center alert alert-danger" },
                            [_vm._v("Instagram business account not found.")]
                          )
                        ])
                  ]
                )
              ])
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 col-lg-6 col-xl-6 d-flex" }, [
      _c("div", { staticClass: "card flex-fill" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("h4", { staticClass: "card-title" }, [_vm._v("Full Access")]),
          _vm._v(" "),
          _c("div", { staticClass: "statistics" }, [
            _c("p", { staticClass: "text-muted" }, [
              _vm._v(
                "Allows Instagram Professionals — Businesses and Creators — to manage its presence on Instagram, find hashtagged media, and get basic metadata and metrics about other Instagram Businesses and Creators."
              )
            ]),
            _vm._v(" "),
            _c("h4", { staticClass: "card-title" }, [
              _vm._v("Before You Start")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text-muted" }, [
              _vm._v("You will need access to the following:")
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _vm._v("\n                      An\n                      "),
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "https://help.instagram.com/502981923235522?fbclid=IwAR0QyyjxqL0PT8WxFogNeNakz1xuvKYmGh53QeqT3IhNhAx3enUUPPL47TE",
                      target: "_blank",
                      rel: "noopener nofollow",
                      "data-lynx-mode": "asynclazy",
                      "data-lynx-uri":
                        "https://l.facebook.com/l.php?u=https%3A%2F%2Fhelp.instagram.com%2F502981923235522%3Ffbclid%3DIwAR0QyyjxqL0PT8WxFogNeNakz1xuvKYmGh53QeqT3IhNhAx3enUUPPL47TE&h=AT3wxMg8_QOoZLOWSDy5Y5ytcMUQDoH_bRCycjha8Pd7dcKMgDHqwvmi1rMquN0a6bgYH1C3wStngFfzQwCcQqS13wv5iFZlvTO-uWVPmUcyXXj4_1VdHdGYmBZtSSHVEqPMuMNdJEY"
                    }
                  },
                  [_vm._v("Instagram Business Account")]
                ),
                _vm._v(" or\n                      "),
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "https://help.instagram.com/1158274571010880?fbclid=IwAR0iKSP5MVPR5-3oxn3N3iNuLf4I3TVEEf8MnumHa4uUsedlxMzCB-MHIZs",
                      target: "_blank",
                      rel: "noopener nofollow",
                      "data-lynx-mode": "asynclazy",
                      "data-lynx-uri":
                        "https://l.facebook.com/l.php?u=https%3A%2F%2Fhelp.instagram.com%2F1158274571010880%3Ffbclid%3DIwAR0iKSP5MVPR5-3oxn3N3iNuLf4I3TVEEf8MnumHa4uUsedlxMzCB-MHIZs&h=AT0T1h-Cl5r2zGniRgPnUvf61PcucFdUDWxcCx63nhpI38PJZy0rXKiDx1TcSd4s28ZbVOJ94cjLzskJ6JGABKf8xC1BZiWsxno_yj9DnW8kgFap59iCBmSK8mIGverB4BnK0LQLWx0"
                    }
                  },
                  [_vm._v("Instagram Creator Account")]
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("\n                      A\n                      "),
                _c(
                  "a",
                  {
                    attrs: {
                      target: "_blank",
                      href:
                        "https://developers.facebook.com/docs/instagram-api/overview#pages"
                    }
                  },
                  [_vm._v("Facebook Page connected to that account")]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("\n                      Brand:\n                      "),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f622eea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f622eea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/instagram/instagramAccount/officialFullAccess.vue
// module id = null
// module chunks = 